import { QuestCategory } from '../types';

export const INITIAL_TOKENS = 3;
export const QUEST_REWARD = 1;

export const CATEGORY_ORDER = [QuestCategory.Creator, QuestCategory.Explorer, QuestCategory.SkillBuilder, QuestCategory.TeamUp];
export const LOCAL_STORAGE_KEY = 'power-up-pact-data';
